/**
 * @ngdoc object
 * @name settings
 * @description
 *
 */
angular
    .module('festzelt-os.settings', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./settings-routes');

// Controllers
require('./controllers/blacklists-controller');
require('./controllers/notifications-controller');
require('./controllers/profile-details-controller');
require('./controllers/profile-edit-controller');

// Factories
require('./factories/setting-factory');

// Workflows
require('./workflows/profile/edit-profile');



// WEBPACK FOOTER //
// ./src/app/pages/settings/settings-module.js